import PageHeader from "src/components/PageHeader";

export default function ShopSettings() {
  return (
    <PageHeader
      title="تنظیمات فروشگاه"
    />
  )
}
